import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import * as React from 'react'

import { cn } from './utils'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    label: React.ReactNode
    checked: boolean
    setChecked: (checked: boolean) => void
  }
>(({ className, id, label, checked, setChecked, ...props }, ref) => {
  return (
    <div className="flex gap-1 items-center">
      <CheckboxPrimitive.Root
        ref={ref}
        id={id}
        className={cn(
          'peer h-[13px] w-[13px] shrink-0 rounded-sm border border-[#4b4949] ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          checked
            ? 'bg-black/90 border-black border-1 text-primary-foreground'
            : '',
          className
        )}
        checked={checked}
        onCheckedChange={setChecked}
        {...props}
      />

      {label && (
        <label
          htmlFor={id}
          className="text-sm leading-none cursor-pointer ml-1"
        >
          {label}
        </label>
      )}
    </div>
  )
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
